<e-popover placement="bottom-end" popovertitle="Conflicten" style="display: inline-block">
  <i popover-button eIcon icon="exclamation-circle" class="text-danger clickable"></i>

  <div popover-content>
    @if (navigationItem.hasObsoleteClickThroughPages) {
      <div class="alert alert-danger m-2">
        Er zijn doorklik pagina's voor dit item opgeslagen die niet langer geconfigureerd zijn:
        @for (item of obsoleteClickTroughItems; track item) {
          <div>
            <b>{{ item.name }} </b><br />
            {{ item.id }}
          </div>
        }
      </div>
    }
    @if (navigationItem.hasMissingClickTroughPages) {
      <div class="alert alert-danger m-2">
        Er zijn doorklikpagina's geconfigureerd die niet zijn opgeslagen:
        <ul>
          @for (id of navigationItem.missingClickThroughPageIds; track id) {
            <li>
              <div>{{ findMatchingEgiPage(id)?.config.name }}</div>
              Id: {{ id }}
            </li>
          }
        </ul>
      </div>
    }

    @if (navigationItem.lacksEgiPage) {
      <div class="alert alert-danger m-2">
        De pagina die bij dit item hoort, bestaat niet meer: {{ navigationItem.pageComponentId }}
      </div>
    }

    @if (!navigationItem.isCompatibleWith(app)) {
      <div class="alert alert-danger m-2">
        Dit item heeft enkele zaken nodig die niet beschikbaar zijn in de app:
        <ul>
          @if (!app.hasPoolName && navigationItem.egiPage.config.dependencies?.poolName) {
            <li>
              Poolnaam
            </li>
          }
          @if (!app.hasMachineName && navigationItem.egiPage.config.dependencies?.machineName) {
            <li>
              Machine naam
            </li>
          }
        </ul>
      </div>
    }
  </div>
</e-popover>
